<template>
  <v-container>
    <v-row align="center" justify="center">
      <v-col xs="12" sm="8" md="6">
        <v-card>
          <!-- <v-spacer></v-spacer>
          <div class="text-center avatar-header">
            <v-avatar :tile="true" :size="150">
              <img src="/static/img/kobe_white.png" alt="Kobe" />
            </v-avatar>
          </div> -->
          <v-spacer></v-spacer>
          <v-card-text>
            <div class="invite-platform-selector" role="radiogroup" aria-label="Select invitation platform">
              <span class="invite-platform-selector__label">Platform</span>
              <v-btn
                v-for="platformOption in invitePlatformOptions"
                :key="platformOption.value"
                text
                small
                class="invite-platform-selector__button"
                :class="{ 'invite-platform-selector__button--active': rdoPlatformOption === platformOption.value }"
                role="radio"
                :aria-checked="String(rdoPlatformOption === platformOption.value)"
                @click="rdoPlatformOption = platformOption.value"
              >
                <span class="invite-platform-selector__logos">
                  <template v-for="(platformLogo, logoIndex) in platformOption.logos">
                    <img
                      v-if="platformLogo.imgIcon"
                      :key="`${platformOption.value}-${logoIndex}`"
                      :src="platformLogo.imgIcon"
                      :alt="`${platformLogo.name} logo`"
                      class="invite-platform-selector__logo"
                    >
                    <v-icon
                      v-else
                      :key="`${platformOption.value}-${logoIndex}`"
                      size="18"
                      :color="platformLogo.iconColor"
                    >
                      {{ platformLogo.icon }}
                    </v-icon>
                  </template>
                </span>
                <span>{{ platformOption.text }}</span>
              </v-btn>
            </div>
            <div v-if="rdoPlatformOption === 'default'">
              <v-text-field
                v-model="name"
                prepend-inner-icon="mdi-account"
                :error-messages="nameErrors"
                @input="$v.name.$touch()"
                @blur="$v.name.$touch()"
                label="Name"
                placeholder="Name"
                outlined
              ></v-text-field>
              <v-text-field
                v-model="igHandle"
                prepend-inner-icon="mdi-instagram"
                label="Instagram Handle"
                placeholder="Instagram Handle"
                outlined
              ></v-text-field>
              <v-text-field
                prepend-inner-icon="fab fa-tiktok"
                v-model="tiktokHandle"
                label="TikTok Handle"
                placeholder="TikTok Handle"
                outlined
              ></v-text-field>
              <v-text-field
                prepend-inner-icon="fab fa-youtube"
                v-model="youtubeHandle"
                label="Youtube Handle or URL"
                placeholder="Youtube Handle or URL"
                outlined
              ></v-text-field>
              <v-combobox
                prepend-inner-icon="my_location"
                v-model="location"
                :items="locations"
                label="Select your location"
                outlined
              ></v-combobox>
            </div>
            <div v-if="rdoPlatformOption === 'xiaohongshu'">
              <v-text-field
                outlined
                placeholder="Enter XHS Fullname"
                label="Enter XHS Fullname"
                prepend-inner-icon="mdi-file-document-outline"
                v-model="xhs.xhsFullname"
                :error-messages="xhsFullnameErrors"
                @input="$v.xhs.xhsFullname.$touch()"
                @blur="$v.xhs.xhsFullname.$touch()"
              ></v-text-field>
              <v-text-field
                outlined
                placeholder="Enter XHS Handle"
                label="Enter XHS Handle"
                prepend-inner-icon="mdi-file-document-outline"
                v-model="xhs.xhsHandle"
                :error-messages="xhsHandleErrors"
                @input="$v.xhs.xhsHandle.$touch()"
                @blur="$v.xhs.xhsHandle.$touch()"
              ></v-text-field>
              <v-text-field
                outlined
                placeholder="Enter XHS ID"
                label="Enter XHS ID"
                prepend-inner-icon="mdi-file-document-outline"
                v-model="xhs.xhsID"
                :error-messages="xhsIDErrors"
                @input="$v.xhs.xhsID.$touch()"
                @blur="$v.xhs.xhsID.$touch()"
                @keyup="changeXhsId()"
              ></v-text-field>
              <v-text-field
                outlined
                placeholder="Enter XHS Total Followers"
                label="Enter XHS Total Followers"
                prepend-inner-icon="mdi-account-group"
                v-model="xhs.totalFollowers"
                type="number"
                :error-messages="xhsTotalFollowersErrors"
                @input="$v.xhs.totalFollowers.$touch()"
                @blur="$v.xhs.totalFollowers.$touch()"
              ></v-text-field>
              <v-text-field
                outlined
                placeholder="Enter XHS Total Likes Favourites"
                label="Enter XHS Total Likes Favourites"
                prepend-inner-icon="mdi-heart"
                v-model="xhs.totalLikesFavourites"
                type="number"
                :error-messages="xhsTotalLikesFavouritesErrors"
                @input="$v.xhs.totalLikesFavourites.$touch()"
                @blur="$v.xhs.totalLikesFavourites.$touch()"
              ></v-text-field>
            </div>
            <div v-if="rdoPlatformOption === 'facebook'">
              <v-text-field
                outlined
                placeholder="Enter Handle"
                label="Enter Handle"
                prepend-inner-icon="mdi-account-group-outline"
                v-model="facebook.fbHandle"
                append-icon="mdi-check-circle-outline"
                :loading="publicProfileLoading === 'facebook'"
                :error-messages="fbHandleErrors"
                @input="$v.facebook.fbHandle.$touch()"
                @blur="$v.facebook.fbHandle.$touch()"
                @click:append="validatePublicProfile('facebook')"
              ></v-text-field>
              <v-text-field
                outlined
                placeholder="Enter Facebook ID"
                label="Enter Facebook ID"
                prepend-inner-icon="mdi-file-document-outline"
                v-model="facebook.fbID"
                @keyup="changeFbId()"
                :error-messages="fbIDErrors"
                @input="$v.facebook.fbID.$touch()"
                @blur="$v.facebook.fbID.$touch()"
              ></v-text-field>
              <v-text-field
                outlined
                placeholder="Enter Total Followers"
                label="Enter Total Followers"
                prepend-inner-icon="mdi-account-group"
                type="number"
                v-model="facebook.totalFollowers"
                :error-messages="fbTotalFollowerErrors"
                @input="$v.facebook.totalFollowers.$touch()"
                @blur="$v.facebook.totalFollowers.$touch()"
              ></v-text-field>
            </div>
            <div v-if="rdoPlatformOption === 'linkedin'">
              <v-text-field
                v-model="name"
                prepend-inner-icon="mdi-account"
                :error-messages="nameErrors"
                @input="$v.name.$touch()"
                @blur="$v.name.$touch()"
                label="Name"
                placeholder="Name"
                outlined
              ></v-text-field>
              <v-text-field
                outlined
                placeholder="Enter LinkedIn Handle"
                label="Enter LinkedIn Handle"
                prepend-inner-icon="mdi-linkedin"
                v-model="linkedin.linkedinHandle"
                append-icon="mdi-check-circle-outline"
                :loading="linkedInLoading"
                :error-messages="linkedinHandleErrors"
                @input="$v.linkedin.linkedinHandle.$touch()"
                @blur="$v.linkedin.linkedinHandle.$touch()"
                @click:append="validateLinkedInProfile"
              ></v-text-field>
              <v-text-field
                outlined
                placeholder="Enter LinkedIn Full Name"
                label="Enter LinkedIn Full Name"
                prepend-inner-icon="mdi-account-card-details"
                v-model="linkedin.linkedinFullname"
                :error-messages="linkedinFullnameErrors"
                @input="$v.linkedin.linkedinFullname.$touch()"
                @blur="$v.linkedin.linkedinFullname.$touch()"
              ></v-text-field>
              <v-text-field
                outlined
                placeholder="Enter Followers"
                label="Followers"
                prepend-inner-icon="mdi-account-group"
                type="number"
                v-model="linkedin.totalFollowers"
                :error-messages="linkedinTotalFollowersErrors"
                @input="$v.linkedin.totalFollowers.$touch()"
                @blur="$v.linkedin.totalFollowers.$touch()"
              ></v-text-field>
            </div>
            <div v-if="rdoPlatformOption === 'twitter'">
              <v-text-field
                v-model="name"
                prepend-inner-icon="mdi-account"
                :error-messages="nameErrors"
                @input="$v.name.$touch()"
                @blur="$v.name.$touch()"
                label="Name"
                placeholder="Name"
                outlined
              ></v-text-field>
              <v-text-field
                outlined
                placeholder="Enter X (Twitter) Handle"
                label="Enter X (Twitter) Handle"
                v-model="twitter.twitterHandle"
                append-icon="mdi-check-circle-outline"
                :loading="publicProfileLoading === 'twitter'"
                :error-messages="twitterHandleErrors"
                @input="$v.twitter.twitterHandle.$touch()"
                @blur="$v.twitter.twitterHandle.$touch()"
                @click:append="validatePublicProfile('twitter')"
              >
                <template v-slot:prepend-inner>
                  <img src="/static/img/x-logo.svg" width="20px" class="mr-2" alt="" aria-hidden="true" />
                </template>
              </v-text-field>
              <v-text-field
                outlined
                placeholder="Enter X Display Name"
                label="Enter X Display Name"
                prepend-inner-icon="mdi-account-card-details"
                v-model="twitter.twitterFullname"
                :error-messages="twitterFullnameErrors"
                @input="$v.twitter.twitterFullname.$touch()"
                @blur="$v.twitter.twitterFullname.$touch()"
              ></v-text-field>
              <v-text-field
                outlined
                placeholder="Enter Total Followers"
                label="Enter Total Followers"
                prepend-inner-icon="mdi-account-group"
                type="number"
                min="0"
                v-model="twitter.totalFollowers"
                :error-messages="twitterTotalFollowersErrors"
                @input="$v.twitter.totalFollowers.$touch()"
                @blur="$v.twitter.totalFollowers.$touch()"
              ></v-text-field>
            </div>
            <v-text-field
              v-model="email"
              prepend-inner-icon="email"
              :error-messages="emailErrors"
              @input="$v.email.$touch()"
              @blur="$v.email.$touch()"
              @keydown.space.prevent
              @paste="preventPasteSpaces" 
              label="Email"
              placeholder="Email"
              outlined
            ></v-text-field>
            <v-layout style="padding: 0px 12px 30px;" row wrap>
              <v-flex xs12 sm12>
                <label class="mt-3">Generate a strong password</label>
                <div class="d-flex flex-row justify-space-between">
                  <span style="font-weight:500;padding-top:6px;">{{generatedPass}}</span>
                  <div>
                    <v-btn @click="copyPass()" icon>
                      <v-icon small>mdi-content-copy</v-icon>
                    </v-btn>
                    <v-btn @click="generatePass()" icon>
                      <v-icon small>mdi-reload</v-icon>
                    </v-btn>
                  </div>
                </div>
              </v-flex>
            </v-layout>
            <v-text-field
              v-model="password"
              :error-messages="passwordErrors"
              @input="$v.password.$touch()"
              @blur="$v.password.$touch()"
              id="regPassword"
              prepend-inner-icon="lock"
              name="regPassword"
              label="Password"
              type="text"
              outlined
            ></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-btn color="secondary" :disabled="!email" @click="registerInf" block>Register</v-btn>
          </v-card-actions>
        </v-card>
        <!-- 
          To Do: Show the pending list of Invitations
        -->
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-data-table
          :headers="headers"
          :items="infUsers"
          :items-per-page="5"
          :search="search"
          class="elevation-1"
        >
          <template v-slot:body="{ items }">
            <tbody>
              <tr v-for="item in items" :key="item.id">
                <td>{{ item.firstName }}</td>
                <td>{{ item.email }}</td>
                <td>
                  <span v-if="item.igHandle" class="social-handle">
                    <v-icon size="18" color="#E4405F">mdi-instagram</v-icon>
                    @{{ item.igHandle }}
                  </span>
                </td>
                <td>
                  <span v-if="item.tiktokHandle" class="social-handle">
                    <img src="/static/img/tiktok-32.png" alt="TikTok" class="social-handle__logo">
                    @{{ item.tiktokHandle }}
                  </span>
                </td>
                <td>
                  <span v-if="item.youtubeHandle" class="social-handle">
                    <v-icon size="18" color="#FF0000">mdi-youtube</v-icon>
                    @{{ item.youtubeHandle }}
                  </span>
                </td>
                <td>
                  <span v-if="item.xhsHandle" class="social-handle">
                    <img src="/static/img/xhs-black.png" alt="Xiaohongshu" class="social-handle__logo">
                    @{{ item.xhsHandle }}
                  </span>
                </td>
                <td>
                  <span v-if="item.fbHandle" class="social-handle">
                    <v-icon size="18" color="#1877F2">mdi-facebook</v-icon>
                    @{{ item.fbHandle }}
                  </span>
                </td>
                <td>
                  <span v-if="item.linkedinHandle" class="social-handle">
                    <v-icon size="18" color="#0A66C2">mdi-linkedin</v-icon>
                    @{{ item.linkedinHandle }}
                  </span>
                </td>
                <td>
                  <span v-if="item.twitterHandle" class="social-handle">
                    <img src="/static/img/x-logo.svg" alt="X" class="social-handle__logo">
                    @{{ item.twitterHandle }}
                  </span>
                </td>
                <td>{{ item.location }}</td>
                <td>{{ formatDate(item.createdAt) }}</td>
                <!-- <td>
                  <v-btn
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Delete"
                    @click="deletePrivateLink(item.id)"
                    color="error"
                    class="ims-action"
                  >
                    <v-icon small>delete</v-icon>
                  </v-btn>
                </td> -->
              </tr>
            </tbody>
          </template>
        </v-data-table>
        <v-snackbar
          v-model="copySucceeded"
        >
          Copied to Clipboard!
          <v-btn
            color="blue"
            text
            @click="copySucceeded = false"
          >
            Close
          </v-btn>
        </v-snackbar>
      </v-col>
    </v-row>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
      loader="bars"
      background-color="#000"
      color="secondary"
      width.number="180"
      height.number="180"
    />
    <input type="hidden" id="copy-pass" :value="generatedPass">
  </v-container>
</template>
<script>
import userAPIs from './userAPIs';
import moment from 'moment';
import reverse from 'lodash/reverse';
import utils from '@/utils';
import config from '@/config'
import Loading from 'vue-loading-overlay';
import { required, email } from 'vuelidate/lib/validators';
import { validationMixin } from 'vuelidate';
import countries from '../../../../static/sources/countries';
export default {
  name: 'CreatePrivateLink',
  mixins: [validationMixin],
  components: {
    Loading
  },
  data() {
    return {
      platform: 'instagram',
      rdoPlatformOption: 'default',
      search: '',
      name: '',
      email: '',
      location: '',
      igHandle: '',
      tiktokHandle: '',
      youtubeHandle: '',
      password: '',
      generatedPass: '',
      xhs: {
        xhsFullname: '',
        xhsHandle: '',
        xhsID: '',
        totalFollowers: '',
        totalLikesFavourites: ''
      },
      facebook: {
        fbFullname: '',
        fbHandle: '',
        fbID: '',
        totalFollowers: ''
      },
      linkedin: {
        linkedinFullname: '',
        linkedinHandle: '',
        totalFollowers: ''
      },
      linkedInLoading: false,
      validatedLinkedInHandle: '',
      publicProfileLoading: '',
      validatedFacebookHandle: '',
      validatedTwitterHandle: '',
      twitter: {
        twitterFullname: '',
        twitterHandle: '',
        totalFollowers: ''
      },
      invitePlatformOptions: [
        {
          text: 'IG / TikTok / YouTube',
          value: 'default',
          logos: [
            { name: 'Instagram', icon: 'mdi-instagram', iconColor: '#111111' },
            { name: 'TikTok', imgIcon: '/static/img/tiktok-32.png' },
            { name: 'YouTube', icon: 'mdi-youtube', iconColor: '#ff0000' }
          ]
        },
        {
          text: 'XHS',
          value: 'xiaohongshu',
          logos: [{ name: 'XHS', imgIcon: '/static/img/xhs-black.png' }]
        },
        {
          text: 'Facebook',
          value: 'facebook',
          logos: [{ name: 'Facebook', icon: 'mdi-facebook', iconColor: '#1877f2' }]
        },
        {
          text: 'LinkedIn',
          value: 'linkedin',
          logos: [{ name: 'LinkedIn', icon: 'mdi-linkedin', iconColor: '#0a66c2' }]
        },
        {
          text: 'X (Twitter)',
          value: 'twitter',
          logos: [{ name: 'X (Twitter)', imgIcon: '/static/img/x-logo.svg' }]
        }
      ],
      copySucceeded: false,
      pendingUsers: [],
      locations: [],
      headers: [
        {
          text: 'Name',
          value: 'name'
        },
        {
          text: 'Email',
          value: 'email'
        },
        {
          text: 'Instagram Handle',
          value: 'igHandle'
        },
        {
          text: 'TikTok Handle',
          value: 'tiktokHandle'
        },
        {
          text: 'Youtube Handle',
          value: 'youtubeHandle'
        },
        {
          text: 'XHS Handle',
          value: 'xhsHandle'
        },
        {
          text: 'Facebook Handle',
          value: 'fbHandle'
        },
        {
          text: 'LinkedIn Handle',
          value: 'linkedinHandle'
        },
        {
          text: 'X Handle',
          value: 'twitterHandle'
        },
        {
          text: 'Location',
          value: 'location'
        },
        {
          text: 'Created At',
          value: 'createdAt'
        }
        // {
        //   text: 'Actions',
        //   value: 'action',
        //   sortable: false
        // }
      ],
      infUsers: [],
      isLoading: false
    };
  },
  validations: function() {
    const validationRules = {
      name: { required },
      email: { required, email },
      password: { required }
    }
    if (this.rdoPlatformOption === 'xiaohongshu') {
      validationRules.xhs = {
        xhsFullname: { required },
        xhsHandle: { required },
        xhsID: { required },
        totalFollowers: { required },
        totalLikesFavourites: { required }
      }
    }
    if (this.rdoPlatformOption === 'facebook') {
      validationRules.facebook = {
        fbFullname: { required },
        fbHandle: { required },
        fbID: { required },
        totalFollowers: { required }
      }
    }
    if (this.rdoPlatformOption === 'linkedin') {
      validationRules.linkedin = {
        linkedinFullname: { required },
        linkedinHandle: { required },
        totalFollowers: { required }
      }
    }
    if (this.rdoPlatformOption === 'twitter') {
      validationRules.twitter = {
        twitterFullname: { required },
        twitterHandle: { required },
        totalFollowers: { required }
      }
    }
    return validationRules
  },
  computed: {
    nameErrors() {
      const errors = [];
      if (!this.$v.name.$dirty) return errors;
      !this.$v.name.required && errors.push('name is required');
      return errors;
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      !this.$v.email && errors.push('Must be valid e-mail');
      !this.$v.email.required && errors.push('E-mail is required');
      return errors;
    },
    passwordErrors() {
      const errors = [];
      if (!this.$v.password.$dirty) return errors;
      !this.$v.password.required && errors.push('password is required');
      return errors;
    },
    xhsFullnameErrors() {
      const errors = [];
      if (!this.$v.xhs.xhsFullname.$dirty) return errors;
      !this.$v.xhs.xhsFullname.required && errors.push('XHS Fullname is required');
      return errors;
    },
    xhsHandleErrors() {
      const errors = [];
      if (!this.$v.xhs.xhsHandle.$dirty) return errors;
      !this.$v.xhs.xhsHandle.required && errors.push('XHS Handle is required');
      return errors;
    },
    xhsIDErrors() {
      const errors = [];
      if (!this.$v.xhs.xhsID.$dirty) return errors;
      !this.$v.xhs.xhsID.required && errors.push('XHS ID is required');
      return errors;
    },
    xhsTotalFollowersErrors() {
      const errors = [];
      if (!this.$v.xhs.totalFollowers.$dirty) return errors;
      !this.$v.xhs.totalFollowers.required && errors.push('XHS Total Followers is required');
      return errors;
    },
    xhsTotalLikesFavouritesErrors() {
      const errors = [];
      if (!this.$v.xhs.totalLikesFavourites.$dirty) return errors;
      !this.$v.xhs.totalLikesFavourites.required && errors.push('XHS Total Likes Favourites is required');
      return errors;
    },
    fbHandleErrors() {
      const errors = [];
      if (!this.$v.facebook.fbHandle.$dirty) return errors;
      !this.$v.facebook.fbHandle.required && errors.push('Facebook Handle is required');
      return errors;
    },
    fbIDErrors() {
      const errors = [];
      if (!this.$v.facebook.fbID.$dirty) return errors;
      !this.$v.facebook.fbID.required && errors.push('Facebook ID is required');
      return errors;
    },
    fbTotalFollowerErrors() {
      const errors = [];
      if (!this.$v.facebook.totalFollowers.$dirty) return errors;
      !this.$v.facebook.totalFollowers.required && errors.push('Facebook Total Followers is required');
      return errors;
    },
    linkedinFullnameErrors() {
      const errors = [];
      if (!this.$v.linkedin.linkedinFullname.$dirty) return errors;
      !this.$v.linkedin.linkedinFullname.required && errors.push('LinkedIn Full Name is required');
      return errors;
    },
    linkedinHandleErrors() {
      const errors = [];
      if (!this.$v.linkedin.linkedinHandle.$dirty) return errors;
      !this.$v.linkedin.linkedinHandle.required && errors.push('LinkedIn Handle is required');
      return errors;
    },
    linkedinTotalFollowersErrors() {
      const errors = [];
      if (!this.$v.linkedin.totalFollowers.$dirty) return errors;
      !this.$v.linkedin.totalFollowers.required && errors.push('Followers (Connections) is required');
      return errors;
    },
    twitterFullnameErrors() {
      const errors = []
      if (!this.$v.twitter.twitterFullname.$dirty) return errors
      !this.$v.twitter.twitterFullname.required && errors.push('X display name is required')
      return errors
    },
    twitterHandleErrors() {
      const errors = []
      if (!this.$v.twitter.twitterHandle.$dirty) return errors
      !this.$v.twitter.twitterHandle.required && errors.push('X handle is required')
      return errors
    },
    twitterTotalFollowersErrors() {
      const errors = []
      if (!this.$v.twitter.totalFollowers.$dirty) return errors
      !this.$v.twitter.totalFollowers.required && errors.push('X total followers is required')
      return errors
    }
  },
  watch: {
    rdoPlatformOption: {
      handler(newValue, oldValue) {
        this.email = ''
        this.password = ''
        if (newValue === 'xiaohongshu') {
          this.changeXhsId()
        }
        if (newValue === 'facebook') {
          this.changeFbId()
        }
      }
    },
    'facebook.fbHandle'(value) {
      if ((value || '').trim().replace(/^@+/, '') !== this.validatedFacebookHandle) this.validatedFacebookHandle = ''
    },
    'twitter.twitterHandle'(value) {
      if (this.normalizeTwitterHandle(value) !== this.validatedTwitterHandle) this.validatedTwitterHandle = ''
    }
  },
  methods: {
    // Prevent pasting spaces
    preventPasteSpaces(event) {
      let pastedText = (event.clipboardData || window.clipboardData).getData('text');
      if (/\s/.test(pastedText)) {
        event.preventDefault(); // Stops the paste action
      }
    },
    getLocations() {
      this.locations = countries.map(element => element.name);
    },
    formatDate(date, format = 'll') {
      return moment(date).format(format)
    },
    handleCopyStatus(status) {
      this.copySucceeded = status
    },
    getPendingRegistrations() {
      console.log('fetching pending registrations')
      userAPIs
        .getPendingTokenRegistrations()
        .then((response) => {
          this.pendingUsers = response.pendingUsers
          this.pendingUsers = reverse(this.pendingUsers)
        })
    },
    async registerInf() {
      if (this.rdoPlatformOption === 'linkedin') {
        this.linkedin.linkedinHandle = this.normalizeLinkedInHandle(this.linkedin.linkedinHandle)
        this.$v.linkedin.linkedinHandle.$touch()
        if (this.$v.linkedin.linkedinHandle.$invalid) return
        if (!await this.validateLinkedInProfile()) return
        this.$v.linkedin.$touch()
        this.$v.name.$touch()
        if (this.$v.linkedin.$invalid || this.$v.name.$invalid) {
          this.$swal({
            text: 'Please complete the required LinkedIn details',
            type: 'info'
          });
          return
        }
      }
      if (this.rdoPlatformOption === 'twitter') {
        this.twitter.twitterHandle = this.normalizeTwitterHandle(this.twitter.twitterHandle)
        if (!this.twitter.twitterHandle) {
          this.$v.twitter.twitterHandle.$touch()
          return
        }
        if (!await this.validatePublicProfile('twitter')) return
        this.$v.twitter.$touch()
        this.$v.name.$touch()
        if (this.$v.twitter.$invalid || this.$v.name.$invalid) {
          this.$swal({
            text: 'Please complete the required X details',
            type: 'info'
          })
          return
        }
      }
      if (this.rdoPlatformOption === 'facebook') {
        if (!this.facebook.fbHandle) {
          this.$v.facebook.fbHandle.$touch()
          return
        }
        if (!await this.validatePublicProfile('facebook')) return
        this.$v.facebook.$touch()
        if (this.$v.facebook.$invalid) {
          this.$swal({ text: 'Please complete the required Facebook details', type: 'info' })
          return
        }
      }
      if (!this.rdoPlatformOption === 'facebook' && !this.rdoPlatformOption === 'xiaohongshu') {
        if (!this.igHandle && !this.tiktokHandle && !this.youtubeHandle) {
          this.$swal({
            text: 'Please enter Instagram, TikTok or Youtube Handle',
            type: 'info'
          });
          return
        }
      }
      if (!this.password) {
        this.$swal({
          text: 'Please enter Password',
          type: 'info'
        });
        return
      }
      let payload = {
        name: this.name,
        email: this.email.toLowerCase(),
        igHandle: utils.func.espaceHandleSign(utils.func.regexMatchIg(this.igHandle, config.regexPattern.instagram_profile)),
        tiktokHandle: utils.func.espaceHandleSign(utils.func.extractTikTokHandle(this.tiktokHandle)),
        youtubeHandle: this.youtubeHandle,
        platform: this.rdoPlatformOption,
        location: this.location,
        password: this.password,
        xhs: this.xhs,
        facebook: this.facebook,
        linkedin: this.linkedin,
        twitter: this.twitter
      }
      this.isLoading = true
      userAPIs
        .createPrivateLink(payload)
        .then(() => {
          this.isLoading = false
          this.$swal({
            title: 'Success',
            text: 'Account Created Successfully.',
            type: 'success'
          });
          this.getRegisteredUsers()
        })
        .catch(error => {
          this.isLoading = false
          const responseData = error && error.response ? error.response.data : null
          const errorMessage = typeof responseData === 'string'
            ? responseData
            : (responseData && responseData.message) || error.message || 'Unable to create the influencer account'
          console.error(responseData || error);
          if (errorMessage.includes('registered')) {
            this.$swal({
              text: errorMessage,
              type: 'info',
              showCancelButton: true,
              confirmButtonText: 'Go to IMS Influencer',
              cancelButtonText: 'Close'
            }).then(result => {
              // Update submitting status
              if (result.value) {
                if (errorMessage.includes('registered')) {
                  this.$router.push({path: '/influencers'})
                }
              }
            })
          } else {
            this.$swal({
              text: errorMessage,
              type: 'info'
            })
          }
        });
    },
    deletePrivateLink(id) {
      // Display confirmation box
      this.$swal({
        title: 'Deleting',
        text: 'Are you sure you want to delete this link?',
        type: 'error',
        showCancelButton: true,
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
        showCloseButton: true,
        showLoaderOnConfirm: true,
        preConfirm: () => {
          return userAPIs
            .deletePrivateLink(id)
            .then((response) => {
              return response
            })
            .catch(error => {
              console.error(error.response.data);
              this.$swal({
                title: 'Error',
                text: error.response.data,
                type: 'error'
              });
            });
        },
        allowOutsideClick: () => !this.$swal.isLoading()
      }).then(result => {
        if (result.value) {
          // Show success message
          this.$swal({
            title: 'Success',
            text: 'Successfully Deleted ',
            type: 'success'
          });
          this.getPendingRegistrations()
        } else {
          // Do nothing for now
        }
      });
    },
    copyPass() {
      setTimeout(function() { utils.func.copyToClipboard('#copy-pass') }, 100)
      this.password = this.generatedPass
    },
    generatePass: function() {
      this.generatedPass = utils.func.generatePassword()
    },
    async getRegisteredUsers() {
      // Get all CO user by role
      let resp = await userAPIs.getAllUsersByRoleSource(config.userRoles.INFLUENCER, 'inviteToIMS')
      if (resp) this.infUsers = resp.users
    },
    changeXhsId() {
      if (this.xhs.xhsID) {
        this.email = `${this.xhs.xhsID}@getkobe.com`
      }
    },
    changeFbId() {
      if (this.facebook.fbID) {
        this.email = `${this.facebook.fbID}@getkobe.com`
      }
    },
    normalizeLinkedInHandle(value) {
      let handle = (value || '').trim()
      const linkedinUrl = handle.match(/^(?:https?:\/\/)?(?:www\.)?linkedin\.com\/in\/([^/?#]+)/i)
      if (linkedinUrl) {
        handle = linkedinUrl[1]
      }
      return handle.replace(/^@+/, '').replace(/\/+$/, '').trim()
    },
    async validateLinkedInProfile() {
      const handle = this.normalizeLinkedInHandle(this.linkedin.linkedinHandle)
      if (!handle) return false
      if (this.validatedLinkedInHandle === handle && this.linkedin.linkedinFullname) return true
      this.linkedInLoading = true
      try {
        const response = await userAPIs.getLinkedInProfile(handle)
        const profile = response && response.user_profile
        if (!response || response.success !== true || !profile || !profile.username || !profile.fullname) {
          throw new Error('Unable to validate the LinkedIn profile')
        }
        this.linkedin.linkedinHandle = profile.username
        this.linkedin.linkedinFullname = profile.fullname
        if (profile.followers !== null && profile.followers !== undefined) {
          this.linkedin.totalFollowers = profile.followers
        }
        if (!this.name) this.name = profile.fullname
        this.validatedLinkedInHandle = profile.username
        if (profile.followers === null || profile.followers === undefined) {
          this.$swal({
            type: 'info',
            text: 'LinkedIn profile verified, but its follower count is not public. Enter the follower count manually to continue.'
          })
        }
        return true
      } catch (error) {
        const responseData = error && error.response ? error.response.data : null
        if (error && error.response && error.response.status === 503) {
          this.validatedLinkedInHandle = handle
          return true
        }
        this.validatedLinkedInHandle = ''
        const message = responseData && responseData.message
          ? responseData.message
          : (error.message || 'Unable to validate the LinkedIn profile')
        this.$swal({ type: 'error', text: message })
        return false
      } finally {
        this.linkedInLoading = false
      }
    },
    async validatePublicProfile(platform) {
      const isFacebook = platform === 'facebook'
      const enteredHandle = isFacebook ? this.facebook.fbHandle : this.twitter.twitterHandle
      const handle = isFacebook
        ? (enteredHandle || '').trim().replace(/^@+/, '')
        : this.normalizeTwitterHandle(enteredHandle)
      if (!handle) return false
      const validatedKey = isFacebook ? 'validatedFacebookHandle' : 'validatedTwitterHandle'
      const fullName = isFacebook ? this.facebook.fbFullname : this.twitter.twitterFullname
      if (this[validatedKey] === handle && fullName) return true
      this.publicProfileLoading = platform
      try {
        const response = await userAPIs.getPublicProfile(platform, handle)
        const profile = response && response.user_profile
        if (!response || response.success !== true || !profile || !profile.username || !profile.fullname) {
          throw new Error(`Unable to validate the ${isFacebook ? 'Facebook' : 'X'} profile`)
        }
        if (isFacebook) {
          this.facebook.fbHandle = profile.username
          this.facebook.fbFullname = profile.fullname
          if (profile.id) this.facebook.fbID = profile.id
          if (profile.followers !== null && profile.followers !== undefined) this.facebook.totalFollowers = profile.followers
          this.changeFbId()
        } else {
          this.twitter.twitterHandle = profile.username
          this.twitter.twitterFullname = profile.fullname
          if (profile.followers !== null && profile.followers !== undefined) this.twitter.totalFollowers = profile.followers
        }
        if (!this.name) this.name = profile.fullname
        this[validatedKey] = profile.username
        if (profile.followers === null || profile.followers === undefined) {
          this.$swal({
            type: 'info',
            text: `${isFacebook ? 'Facebook' : 'X'} profile verified, but its follower count is not public. Enter it manually to continue.`
          })
        }
        return true
      } catch (error) {
        const responseData = error && error.response ? error.response.data : null
        if (error && error.response && error.response.status === 503) {
          this[validatedKey] = handle
          return true
        }
        this[validatedKey] = ''
        const message = responseData && responseData.message
          ? responseData.message
          : (error.message || `Unable to validate the ${isFacebook ? 'Facebook' : 'X'} profile`)
        this.$swal({ type: 'error', text: message })
        return false
      } finally {
        this.publicProfileLoading = ''
      }
    },
    normalizeTwitterHandle(value) {
      let handle = (value || '').trim()
      const twitterUrl = handle.match(/^(?:https?:\/\/)?(?:www\.)?(?:x|twitter)\.com\/([^/?#]+)/i)
      if (twitterUrl) handle = twitterUrl[1]
      return handle.replace(/^@+/, '').replace(/\/+$/, '').trim()
    }
  },
  mounted() {
    this.getLocations()
    // this.getPendingRegistrations()
    this.getRegisteredUsers()
    this.generatePass()
  }
};
</script>

<style scoped>
.invite-platform-selector {
  align-items: center;
  background: #f7f8fa;
  border: 1px solid #e4e7ec;
  border-radius: 12px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 24px;
  padding: 10px 12px;
}
.invite-platform-selector__label {
  color: #475467;
  font-size: 13px;
  font-weight: 600;
  margin-right: 4px;
}
.invite-platform-selector__button {
  background: #ffffff;
  border: 1px solid #d0d5dd;
  border-radius: 9px;
  color: #344054!important;
  letter-spacing: 0!important;
  min-height: 34px;
  text-transform: none;
}
.invite-platform-selector__button--active {
  background: #fff4fb!important;
  border-color: #d82d8b;
  color: #9f145f!important;
}
.invite-platform-selector__logos {
  align-items: center;
  display: inline-flex;
  gap: 4px;
  margin-right: 8px;
}
.invite-platform-selector__logo {
  height: 18px;
  object-fit: contain;
  width: 18px;
}
.social-handle {
  align-items: center;
  display: inline-flex;
  gap: 6px;
  white-space: nowrap;
}
.social-handle__logo {
  height: 18px;
  object-fit: contain;
  width: 18px;
}
@media (max-width: 600px) {
  .invite-platform-selector__label {
    flex-basis: 100%;
  }
  .invite-platform-selector__button {
    flex: 1 1 calc(50% - 8px);
  }
}
</style>



// WEBPACK FOOTER //
// CreatePrivateLink.vue?3e0d95bc